import config from '../../../../../../../../config'

import {
    GET_FAVOURITES,
    ADD_TO_FAVOURITES,
    REMOVE_FROM_FAVOURITES,
    FAVOURITES_LOADED,
    LOAD_FAVOURITES_REQUEST,
    ADD_TO_FAVOURITES_REQUEST,
    REMOVE_FROM_FAVOURITES_REQUEST,
} from './constants'

export function getFavourites() {
    return {
        type: GET_FAVOURITES,
    }
}

export function addToFavourites(entId) {
    return {
        type: ADD_TO_FAVOURITES,
        data: {
            entId,
        },
    }
}

export function removeFromFavourites(entId) {
    return {
        type: REMOVE_FROM_FAVOURITES,
        data: {
            entId,
        },
    }
}

export function favouritesLoaded(entities) {
    return {
        type: FAVOURITES_LOADED,
        data: {
            entities,
        },
    }
}

export function getFavouritesRequest() {
    return {
        type: LOAD_FAVOURITES_REQUEST,
        payload: {
            ...config.api.entityStack.favourites.get,
            qs: {
                limit: 400,
            },
        },
    }
}

export function addToFavouritesRequest(entId) {
    return {
        type: ADD_TO_FAVOURITES_REQUEST,
        payload: {
            ...config.api.entityStack.favourites.add,
            body: {
                entId,
            },
        },
    }
}

export function removeFromFavouritesRequest(entId) {
    return {
        type: REMOVE_FROM_FAVOURITES_REQUEST,
        payload: {
            ...config.api.entityStack.favourites.remove,
            qs: {
                entId,
            },
        },
    }
}
